import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEllipseGreen = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 7, viewBox: "0 0 6 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 3208", cx: 3, cy: 3.5, r: 3, fill: "#36B368" }));
const ForwardRef = forwardRef(SvgEllipseGreen);
const Memo = memo(ForwardRef);
export default Memo;
